// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.service-account-deactivated-content {
  border-top: 1px solid var(--color-border-base);
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/service-accounts/ui/service-account-tile/ServiceAccountDeactivatedContent.less"],"names":[],"mappings":"AAAA;EACE,8CAAA;AACF","sourcesContent":[".service-account-deactivated-content {\n  border-top: 1px solid var(--color-border-base);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
